<div class="deletion-dialogue">
	@if (isLoading) {
		<optima-progress-indicator
			[progress]="loadingProgress"
			[view]="ProcessProgressView.Shimmer"
			[config]="{ shimmer: { variant: ShimmerVariant.Custom, baseColor: shimmerBaseColor, highlightColor: shimmerHighlightColor, items: [
				{ id: 'msg-line',   width: '70%',  height: '1.1rem', marginBottom: '1rem' },
				{ id: 'list-row-1', width: '100%', height: '2.5rem', marginBottom: '0.5rem' },
				{ id: 'list-row-2', width: '100%', height: '2.5rem', marginBottom: '0.5rem' },
				{ id: 'list-row-3', width: '100%', height: '2.5rem' }
			] } }">
		</optima-progress-indicator>
	} @else {
		@if (apiMessage && !apiResponse?.isDeletable) {
			<p class="api-message error-message">{{ apiMessage }}</p>
		}

		<p class="primary-message">{{ primaryMessage }}</p>

		@if (entities.length > 0) {
			<div class="entity-list" role="region" aria-label="Entities involved in deletion">
				<optima-lister
					[list]="entityNamesListView"
					[hasHeader]="false"
					[hasColHeaders]="false"
					[headerSeparator]="false"
					[height]="'10rem'"
				></optima-lister>
			</div>
		}

		@if (confirmationMessage) {
			<p class="confirmation-message">{{ confirmationMessage }}</p>
		}

		@if (hasTxnLogWarning) {
			<p class="txn-log-warning">This item has transactions associated with it. Deleting this item will also delete the transactions.</p>
		}
	}
</div>
